// Shared formatting for the energy page — one place for rupees, units and the
// phase colours, so every card says the same thing the same way.

// R / Y / B, the colours an Indian electrician reads — the desktop card used
// these first (PhaseControlCard).
export const PHASE = {
  1: { label: 'R', name: 'Phase R', color: '#e53935' },
  2: { label: 'Y', name: 'Phase Y', color: '#f9a825' },
  3: { label: 'B', name: 'Phase B', color: '#1e88e5' },
};

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const inr = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
const inr2 = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const rupees = (v) => (v == null || !Number.isFinite(v) ? '—' : `₹${inr.format(Math.round(v))}`);
export const rupees2 = (v) => (v == null || !Number.isFinite(v) ? '—' : `₹${inr2.format(v)}`);
export const kwh = (v, digits = 1) => (v == null || !Number.isFinite(v) ? '—' : `${v.toFixed(digits)} kWh`);
export const watts = (w) => {
  if (w == null || !Number.isFinite(w)) return '—';
  return w >= 1000 ? `${(w / 1000).toFixed(2)} kW` : `${Math.round(w)} W`;
};
export const hourLabel = (h) => (h == null ? '—' : `${String(h % 24).padStart(2, '0')}:00`);

export const shortDate = (ymdStr) => {
  const [y, m, d] = ymdStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

export const dateRange = (start, endExclusive) => {
  const last = new Date(endExclusive.getFullYear(), endExclusive.getMonth(), endExclusive.getDate() - 1);
  const f = (dt) => dt.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${f(start)} – ${f(last)}`;
};

export const duration = (seconds) => {
  const m = Math.round(seconds / 60);
  if (m < 90) return `${m} min`;
  const h = m / 60;
  return h < 48 ? `${h.toFixed(h < 10 ? 1 : 0)} h` : `${(h / 24).toFixed(1)} days`;
};

export const ago = (date) => {
  if (!date) return 'never';
  const s = Math.max(0, Math.round((Date.now() - date) / 1000));
  if (s < 90) return `${s} s ago`;
  return `${duration(s)} ago`;
};
